import { InvoiceHistoryResponse } from '@/components/Billing/billing-types';
import { Response } from '@/react_app/common/AppPagination';
export interface InvoiceDisplay {
	date: string;
	number: string;
	amount: string;
	invoiceUrl: string;
	status: InvoiceStatus;
}
export enum InvoiceStatus {
	Paid = 'paid',
	Unpaid = 'unpaid',
	Rejected = 'rejected',
}
export interface InvoiceHistoryContextType {
	getInvoices: () => Promise<Response<InvoiceHistoryResponse>>;
}
